import { PORTAL_ROUTE_NAMES } from '@app/modules/portal/portal.routes.names';

export const links = {
  primary: [
    {
      title: 'Meu perfil',
      redirectTo: PORTAL_ROUTE_NAMES.PROFILE,
    },
    {
      title: 'Meus contratos',
      redirectTo: PORTAL_ROUTE_NAMES.MY_CONTRACTS,
    },
    {
      title: 'Meus serviços',
      redirectTo: PORTAL_ROUTE_NAMES.TRACK_REQUESTS,
    },
    {
      title: 'Alterar Minha Senha',
      redirectTo: PORTAL_ROUTE_NAMES.PASSWORD,
    },
  ],
  secondary: [
    {
      title: 'Início',
      redirectTo: PORTAL_ROUTE_NAMES.DASHBOARD,
      expanded: false,
    },
    {
      title: 'Contratos',
      redirectTo: PORTAL_ROUTE_NAMES.MY_CONTRACTS,
      expanded: false,
    },
    {
      title: 'Serviços',
      expanded: false,
      children: [
        {
          title: 'Emissão de certificados',
          redirectTo: PORTAL_ROUTE_NAMES.MY_CONTRACTS,
        },
        // {
        //   title: 'Solicite cancelamento',
        //   redirectTo: PORTAL_ROUTE_NAMES.MY_CONTRACTS,
        // },
        {
          title: 'Acompanhar solicitações',
          redirectTo: PORTAL_ROUTE_NAMES.TRACK_REQUESTS,
        },
        {
          title: 'Comunicação de Sinistro',
          redirectTo: PORTAL_ROUTE_NAMES.REPORT_ACCIDENTS,
        },
        {
          title: 'Canal de denúncias',
          redirectTo: PORTAL_ROUTE_NAMES.REPORTS_PORTAL,
        },
      ],
    },
    {
      title: 'Perfil',
      redirectTo: PORTAL_ROUTE_NAMES.PROFILE,
      expanded: false,
    },
    {
      title: 'Ajuda',
      redirectTo: PORTAL_ROUTE_NAMES.FREQUENTLY_ASKED_QUESTIONS,
      expanded: false,
    },
    {
      title: 'Atendimento',
      redirectTo: PORTAL_ROUTE_NAMES.CONTACT_US,
      expanded: false,
    },
    {
      title: 'Política de Privacidade',
      url: 'https://www.sabemi.com.br/politica-de-privacidade',
      expanded: false,
    },
  ],
};
